import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import CryptoJS from "crypto-js";
import axios from "axios";
import APIDataFetchLoader from "../Component/Others/APIDataFetchLoader";

const SiteUrl = process.env.REACT_APP_SITEURL;
const WebsiteAPIurl = SiteUrl + "api/Webapi/";
const SECRET_KEY = process.env.REACT_APP_SECRET_KEY;

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [userID, setUserId] = useState(null);
  const [RendomTokenfetch, setRendomTokenfetch] = useState(null);
  const [profileData, setprofileData] = useState(null);
  const [acountData, setacountData] = useState(null);
  const [userRoll, setuserRoll] = useState("");
  const [vendorRollID, setvendorRollID] = useState("");
  const [webSetting, setwebSetting] = useState([]);
  const [walletbalance, setwalletbalance] = useState(null);

  const [tokenLoading, setTokenLoading] = useState(true);
  const [profileLoading, setProfileLoading] = useState(true);
  const [settingLoading, setSettingLoading] = useState(true);
  // const [WalletBalanceLoading, setWalletBalanceLoading] = useState(true);

  useEffect(() => {
    const FetchRendomToken = async () => {
      setTokenLoading(true);
      try {
        let fdata = new FormData();
        fdata.append("Status", "1");

        const response = await axios.post(
          `${WebsiteAPIurl}rendomTokenfetch`,
          fdata
        );
        // console.log("RendomTokenfetch", response.data);
        if (response.data.token) {
          setRendomTokenfetch(response.data.token);
        }
      } catch (err) {
        console.error("Token Fetch Error:", err.message);
      } finally {
        setTokenLoading(false);
      }
    };

    FetchRendomToken();
  }, []);

  useEffect(() => {
    if (!RendomTokenfetch) return;

    const encryptedUserId = localStorage.getItem("userid");
    if (encryptedUserId) {
      try {
        const bytes = CryptoJS.AES.decrypt(encryptedUserId, SECRET_KEY);
        const decryptedUserId = bytes.toString(CryptoJS.enc.Utf8);
        if (decryptedUserId) {
          setUserId(decryptedUserId);
        }
      } catch (error) {
        console.error("Decryption Error:", error);
      }
    } else {
      setProfileLoading(false); // no userID, skip profile fetch
    }
  }, [RendomTokenfetch]);

  // User Profile Data Fetch
  useEffect(() => {
    const fetchProfile = async () => {
      if (!userID || !RendomTokenfetch) return;

      setProfileLoading(true);
      try {
        let fdata = new FormData();
        fdata.append("userID", userID);

        const res = await axios.post(`${WebsiteAPIurl}userdata`, fdata, {
          headers: { Authorization: RendomTokenfetch },
        });

        if (res.data && res.data.Status === "1") {
          setprofileData(res.data.userdata);
          setacountData(res.data.accountdata);

          const encryptedUserRoll = CryptoJS.AES.encrypt(
            res.data.userdata.role.toString(),
            SECRET_KEY
          ).toString();
          localStorage.setItem("userRoll", encryptedUserRoll);

          setuserRoll(res.data.userdata.role);
          setvendorRollID(res.data.userdata.vendor_role);
        } else {
          console.warn("Profile fetch failed:", res.data?.Message || "Unknown");
        }
        // if (res.data.userdata?.role) {
        //   setuserRoll(res.data.userdata.role);
        // }
      } catch (err) {
        console.error("Profile Fetch Error:", err.message);
      } finally {
        setProfileLoading(false);
      }
    };

    fetchProfile();
  }, [userID, RendomTokenfetch]);

  // Website Setting Data Fetch
  useEffect(() => {
    const fetchWebsiteSetting = async () => {
      if (!RendomTokenfetch) return;
      setSettingLoading(true);
      try {
        const res = await axios.get(`${WebsiteAPIurl}website_setting`, {
          headers: {
            Authorization: RendomTokenfetch,
          },
        });

        if (res.data && res.data.Status === "1") {
          setwebSetting(res.data.sitedata);
        } else {
          console.warn("fetch failed:", res.data?.Message || "Unknown");
        }
      } catch (err) {
        console.error("Fetch Error:", err.message);
      } finally {
        setSettingLoading(false);
      }
    };

    fetchWebsiteSetting();
  }, [RendomTokenfetch]);

  // Wallet Balance Data Fetch
  const fetchWalletBalance = useCallback(async () => {
    if (!userID || !RendomTokenfetch) return null;

    try {
      let fdata = new FormData();
      fdata.append("user_id", userID);

      const res = await axios.post(`${WebsiteAPIurl}walletbalance`, fdata, {
        headers: { Authorization: RendomTokenfetch },
      });

      if (res.data && res.data.status === "1") {
        setwalletbalance(res.data.WalleBalance);
        return res.data.WalleBalance; // ✅ return kara diya
      } else {
        console.warn(
          "Wallet Balance fetch failed:",
          res.data?.message || "Unknown"
        );
        return null;
      }
    } catch (err) {
      console.error("Wallet Balance Fetch Error:", err.message);
      return null;
    }
  }, [userID, RendomTokenfetch]);

  useEffect(() => {
    fetchWalletBalance();
  }, [fetchWalletBalance, userID, RendomTokenfetch]);

  //Update Users
  const updateUser = (newUserId) => {
    if (newUserId) {
      const encryptedUserId = CryptoJS.AES.encrypt(
        newUserId.toString(),
        SECRET_KEY
      ).toString();
      localStorage.setItem("userid", encryptedUserId);
      setUserId(newUserId);
    } else {
      localStorage.removeItem("userid");
      setUserId(null);
      setprofileData(null);
      setacountData(null);
      setuserRoll("");
      setvendorRollID("");
      setwebSetting(null);
      walletbalance(null);
    }
  };

  const isLoading = tokenLoading || profileLoading || settingLoading;

  return (
    <AuthContext.Provider
      value={{
        userID,
        updateUser,
        RendomTokenfetch,
        profileData,
        acountData,
        userRoll,
        vendorRollID,
        webSetting,
        walletbalance,
        fetchWalletBalance,
      }}
    >
      {isLoading ? <APIDataFetchLoader /> : children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
